import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  useRouterState,
} from "@tanstack/react-router"
import { lazy, Suspense, useEffect } from "react"
import { I18nProvider } from "@/lib/i18n"
import { Nav } from "@/components/marketing/nav"
import { Footer } from "@/components/marketing/footer"
import { SideRails } from "@/components/marketing/side-rails"
import { Home } from "@/pages/Home"

const LegalPage = lazy(() =>
  import("@/pages/LegalPage").then((m) => ({ default: m.LegalPage })),
)

function ScrollToTop() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior })
  }, [pathname])
  return null
}

const rootRoute = createRootRoute({
  component: () => (
    <I18nProvider>
      <div className="relative min-h-screen bg-background text-foreground">
        <ScrollToTop />
        <Nav />
        <SideRails />
        <Outlet />
        <Footer />
      </div>
    </I18nProvider>
  ),
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Home,
})

const privacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/privacy",
  component: () => (
    <Suspense fallback={null}>
      <LegalPage doc="privacy" />
    </Suspense>
  ),
})

const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/terms",
  component: () => (
    <Suspense fallback={null}>
      <LegalPage doc="terms" />
    </Suspense>
  ),
})

const routeTree = rootRoute.addChildren([indexRoute, privacyRoute, termsRoute])

export const router = createRouter({ routeTree })

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
